import { createRootRoute, Outlet, Link } from '@tanstack/react-router';
import { Button } from '@truecare/ui';
import { AdminLayout } from '../components/AdminLayout';

/**
 * 404 for an unmatched admin URL — rendered INSIDE the AdminLayout shell (nav +
 * header) with a way back, rather than TanStack Router's bare unstyled default.
 */
function AdminNotFound() {
  return (
    <AdminLayout>
      <div
        className="mx-auto max-w-lg py-20 text-center"
        data-testid="admin-not-found"
      >
        <h1 className="font-heading text-3xl text-forest">Page not found</h1>
        <p className="mt-3 font-body text-ink-muted">
          That admin page doesn&rsquo;t exist — it may have moved, or the link is out
          of date.
        </p>
        <div className="mt-6 flex justify-center">
          <Link to="/">
            <Button>Back to dashboard</Button>
          </Link>
        </div>
      </div>
    </AdminLayout>
  );
}

/**
 * Runtime-error fallback. Deliberately does NOT wrap in AdminLayout — the layout
 * reads the current user, which can itself be the source of the error, and
 * re-rendering it here would risk an error loop.
 */
function AdminError() {
  return (
    <div className="mx-auto max-w-lg px-6 py-20 text-center">
      <h1 className="font-heading text-3xl text-forest">Something went wrong</h1>
      <p className="mt-3 font-body text-ink-muted">
        An unexpected error occurred. Please reload the page; if it keeps
        happening, contact the operator administrator.
      </p>
      <div className="mt-6 flex justify-center">
        <a href="/">
          <Button>Back to dashboard</Button>
        </a>
      </div>
    </div>
  );
}

export const Route = createRootRoute({
  component: () => <Outlet />,
  notFoundComponent: AdminNotFound,
  errorComponent: AdminError,
});
